// export const logoPath = '/assets/elite-logo.png';
// export const schoolName = 'أسرة النخبة التعليمية';
// export const isNukbeh = true;
export const logoPath = '/assets/al-awal-logo.png';
export const schoolName = 'مؤسسة الأول التعليمية الخاصة';
export const isNukbeh = false;